import { render, staticRenderFns } from "./ServiceCenterViewContacts.vue?vue&type=template&id=6ad9599f"
import script from "./ServiceCenterViewContacts.vue?vue&type=script&lang=js"
export * from "./ServiceCenterViewContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports